import Vue from 'vue'
import Vuetify from 'vuetify'

Vue.use(Vuetify)

const vuetify = new Vuetify({
	theme: {
		themes: {
			light: {
				primary: '#047857',
				secondary: {
					base: '#FFFFFF',
					lighten2: '#E8ECF2',
					lighten3: '#7D8FAB',
				},
				grey: '#CCD3DB',
				primaryLight: '#E6F2EF',
				success: '#24C9A1',
				successLight: '#c4f3e8',
				dangerLight: '#ffd1ce',
				info: '#2196f3',
				skyBlueLight: '#E6F4F9',
				blueLight: '#DDEFF8',
				orangesLight: '#FFF2D9',
				redLight: '#FBE5E2',
				footer: '#071110',
				orange: '#FFB800',
			},
			dark: {
				primary: '#047857',
				secondary: {
					base: '#FFFFFF',
					lighten2: '#545353',
				},
				grey: '#CCD3DB',
				primaryLight: '#E6F2EF',
				success: '#24C9A1',
				successLight: '#c4f3e8',
				dangerLight: '#ffd1ce',
				info: '#2196f3',
				footer: '#071110',
			},
		},
		options: {
			customProperties: true,
		},
	},
})

export default vuetify
